export default "__VITE_ASSET__Dp4T92qs__"